import { FC, memo } from "react";
import { TreatmentPlanStatus } from "../../../../../../services/api-client/contact-api.types"
import { CompleteStatus, PendingStatus, StandardStatus, SuccessStatus } from "../../patient-profile-widget.styles"
import { SxProps } from '@mui/material'

export interface TreatmentPlanStatusComponentProps {
  status: TreatmentPlanStatus;
  sx?: SxProps
}

export const TreatmentPlanStatusComponent: FC<TreatmentPlanStatusComponentProps> = memo((props) => {
  const { status, sx } = props;

  switch (status) {
    case "Proposed":
      return <PendingStatus sx={sx}>Proposed</PendingStatus>
    case "Accepted":
      return <CompleteStatus sx={sx}>Accepted</CompleteStatus>
    case "Scheduled":
      return <SuccessStatus sx={sx}>Scheduled</SuccessStatus>
    default:
      return <StandardStatus sx={sx}>{props.status}</StandardStatus>
  }
});